import {
  Box,
  ListItemButton,
  ListItemText,
  List,
  Typography
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { ListItemIcon } from "@mui/material";
import SettingsLayout from "./SettingsLayout";
import {
  NotificationsOutlined,
  EventNoteOutlined,
  ContentPasteSearchOutlined,
  PendingActionsOutlined,
  EventBusyOutlined
} from "@mui/icons-material";
import { ListItem } from "@mui/material";

const menuItems = [
  {
    label: "Plan of Care",
    icon: <EventNoteOutlined />,
    path: "/dashboard/settings/functional-modules"
  },
  {
    label: "Waitlist",
    icon: <PendingActionsOutlined />,
    path: "/dashboard/settings/functional-modules/waitlist"
  },
  {
    label: "Initial Visit",
    icon: <ContentPasteSearchOutlined />,
    path: "/dashboard/settings/functional-modules/initial-visit"
  },
  {
    label: "Reminders",
    icon: <NotificationsOutlined />,
    path: "/dashboard/settings/functional-modules/reminders"
  },
  {
    label: "Cancellation",
    icon: <EventBusyOutlined />,
    path: "/dashboard/settings/functional-modules/cancellation"
  }
];

export default function FunctionalModulesLayout({
  children
}: {
  children: React.ReactNode;
}) {
  const drawerWidth = 300; // Match DashboardSidebar drawer width

  return (
    <SettingsLayout>
      <Box sx={{ position: "relative", minHeight: "100%" }}>
        <Box
          sx={{
            position: "fixed",
            left: {
              xs: "288px",
              lg: `${drawerWidth + 304}px` // Dashboard sidebar + 280px (first settings sidebar + gap) + 24px padding
            },
            top: { xs: "120px", lg: "160px" }, // Same as SettingsLayout content top
            bottom: 0,
            width: "240px",
            overflow: "auto",
            "&::-webkit-scrollbar": {
              width: "12px"
            },
            "&::-webkit-scrollbar-track": {
              background: "rgba(255, 255, 255, 0.05)"
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgba(255, 255, 255, 0.3)",
              borderRadius: "6px",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.4)"
              }
            },
            scrollbarWidth: "thin",
            scrollbarColor: "rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05)"
          }}
        >
          <ModulesMenu />
        </Box>
        <Box
          sx={{
            marginLeft: "280px", // 240px second sidebar + 40px gap
            paddingLeft: "10px",
            minHeight: "100%"
          }}
        >
          {children}
        </Box>
      </Box>
    </SettingsLayout>
  );
}

function ModulesMenu() {
  const location = useLocation();

  return (
    <div>
      <Typography variant="h6">Modules</Typography>
      <List
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "240px"
        }}
      >
        {menuItems.map((item) => (
          <ListItem key={item.path} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              component={Link}
              to={item.path}
              sx={{ borderRadius: "8px" }}
            >
              <ListItemIcon
                sx={{ fontSize: "20px", minWidth: "40px !important" }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );
}
